import { type RangeFilterInput } from '@/generated/graphql-types'

const hasBothUndefinedRangeValues = (min?: number, max?: number) => {
  return typeof min === 'undefined' && typeof max === 'undefined'
}

/**
 * Update array of range filters
 */
export const updateRangeFilter = ({
  filterName,
  max,
  min,
  rangeFilters,
}: {
  filterName: RangeFilterInput['filterName']
  max?: number
  min?: number
  rangeFilters: RangeFilterInput[]
}): RangeFilterInput[] => {
  /** If both range values are undefined, do not include the filter in the array */
  if (hasBothUndefinedRangeValues(min, max)) {
    return rangeFilters.filter((filter) => {
      return filter.filterName !== filterName
    })
  }

  /** Find the filter to update in the array containing all the current filter state */
  const rangeToUpdate = rangeFilters.find((item) => item.filterName === filterName)

  /** If the filter to update is not in the array, push it to the array */
  if (!rangeToUpdate) {
    rangeFilters.push({ filterName, minValue: min, maxValue: max })
    return rangeFilters
  }

  /** If the filter to update is in the array, then update the value */
  return rangeFilters.reduce((acc: RangeFilterInput[], curr: RangeFilterInput) => {
    if (curr.filterName !== filterName) return [...acc, curr]

    /** Update the values for the selected filter */
    return [...acc, { filterName: curr.filterName, minValue: min, maxValue: max }]
  }, [])
}
